export const addStaticSubdomain = (url?: string) => {
  const sourceDomain = "https://amityonline.com";
  const staticDomain = "https://static.amityonline.com";

  if (url?.startsWith(sourceDomain)) {
    return url?.replace(sourceDomain, staticDomain);
  } else if (!url?.startsWith("https://")) {
    return staticDomain + "/" + url;
  }

  return url;
}